// models/produtos/combos/ConjuntoItem.js
import { Conjunto } from "./Conjunto";
import { Produto } from "../Produto";

export class ConjuntoItem {
  constructor() {
    this.id = 0;
    this.conjuntoId = 0;
    this.produtoId = 0;
    this.variacao = "";
    this.valorAdicional = null;
    this.inativo = false;
    this.conjunto = new Conjunto();  // objeto Conjunto (instanciado por padrão)
    this.produto = new Produto();;    // objeto Produto (instanciado por padrão)
  }
}
